<template>
	<div class="bottombar">
		<span class="text-container">
			{{ $tr.product.totalPrice }} <strong>{{ $db.totalPrice() }}</strong>
		</span>
        <div class="d-flex d-lg-none bottombar-progress">
            <slot></slot>
        </div>
        <span class="buttons-container">
            <Button v-if="typeof current === 'undefined' || current !== 0" @click="goToPrevStep" type="go-back" size="small">
                {{ $tr.backBtn }}
            </Button>
            <template v-if="customButtons">
                <slot name="custom-buttons"></slot>
            </template>
            <template v-else>
                <Button @click="goToNextStep" type="black" size="lg">
                    {{ $tr.nextStepBtn }} <span class="additional desktop-only">{{ current+2 }}/{{ total }}</span>
                </Button>
            </template>
        </span>
	</div>
</template>

<script>
	import Button from "../common/Button";

	export default {
		name: "BottomBar",
		components: {
			Button
		},
		props: [
			"current",
			"total",
            "customButtons"
		],
		methods: {
			goToPrevStep() {
				this.$emit("goToStep", "-1");
			},
			goToNextStep() {
				this.$emit("goToStep", "+1");
			}
		}
	}
</script>
